var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 3500",
    style: {
      enableBackground: "new 0 0 5000 3500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9A3B82;}\n\t.st1{fill:#FFCF2D;}\n\t.st2{fill:#FFFFFF;stroke:#FFCF2D;stroke-width:5;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFCF2D;stroke-width:5;stroke-miterlimit:10;}\n\t.st4{fill:#66B0F0;stroke:#FFCF2D;stroke-width:5;stroke-miterlimit:10;}\n\t.st5{fill:#FE5244;}\n\t.st6{fill:#A0505A;}\n\t.st7{fill:#73325A;}\n\t.st8{fill:none;stroke:#73325A;stroke-width:5;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#FFCF2D;stroke-width:6;stroke-miterlimit:10;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:none;stroke:#9A3B82;stroke-width:6;stroke-miterlimit:10;}\n\t.st12{fill:#66B0F0;}\n\t.st13{fill:#3FB1B5;}\n\t.st14{fill:none;stroke:#66B0F0;stroke-width:6;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FE5244;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#FE5244;stroke-width:6;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st18{fill:#E57281;}\n\t.st19{fill:none;stroke:#9A3B82;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st20{fill:#66B0F0;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\n\t.st21{fill:#FFFFFF;stroke:#FE5244;stroke-width:5;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#73325A;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35__HAND__x26__CAP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAND_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DRESS_6_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4042.9,2605l0,329.9h-496.3l96.7-506.6c-3.1,20,58.8,57.5,143.5,95.1c30.4,13.5,64.3,26.9,100.5,39.6 C3945.7,2583.6,3999.5,2597.6,4042.9,2605C4042.8,2605,4042.9,2605,4042.9,2605z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4042.9,2505.8v88.3c-43.4-7.4-97.1-21.3-155.7-41.9c-138.1-48.5-244.4-108.4-238.4-135.3 c0.1-0.4,0.2-0.8,0.3-1.1c9.3-26.3,131.6-8.1,271.6,41c45,15.8,85.6,32.1,119.7,47.8C4041.2,2505,4042,2505.4,4042.9,2505.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DIPLOMA_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3974.8,1741.4c-48.4,0-87.6,39.2-87.6,87.5v239.8c0,48.3-39.2,87.5-87.5,87.5h-350.8 c48.4,0,87.5-39.2,87.5-87.5v-239.8c0-48.4,39.2-87.5,87.5-87.5H3974.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3598,
    y: 1865.5,
    className: "st2",
    width: 223.4,
    height: 207.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 1895.1,
    x2: 3598,
    y2: 1895.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 1924.7,
    x2: 3598,
    y2: 1924.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 1954.4,
    x2: 3598,
    y2: 1954.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 1984,
    x2: 3598,
    y2: 1984
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 2013.7,
    x2: 3598,
    y2: 2013.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3821.3,
    y1: 2043.3,
    x2: 3598,
    y2: 2043.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3887.2,1828.9c0-48.1,38.8-87.1,86.7-87.5c48,0.4,86.7,39.4,86.7,87.5H3887.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3800.1,2158.4c-0.1,0-0.3,0-0.4,0h-349.5c-0.2,0-0.4,0-0.6,0c-35.9-0.5-66.6-22.7-79.6-54.1h350.2 C3733.3,2135.7,3764,2157.9,3800.1,2158.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3612.6,1841.7h-40.4v-32.4h19v18c0,0.4,0.2,0.7,0.4,0.8c0,0,0.1,0.1,0.1,0.1L3612.6,1841.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3628.3,1820.5v4.3c0,0.8-0.1,1.6-0.1,2.4c0,0.2-0.1,0.5-0.1,0.7c-0.1,0.4-0.1,0.8-0.2,1.2 c-1.1,5.5-4.4,10-8.5,11.7c-0.3,0.1-0.6,0.2-0.9,0.3c-0.5,0.2-1.1,0.3-1.6,0.4c-0.2,0-0.4,0.1-0.6,0.1l-22.9-14.9 c0.2-3.5,2.4-6.3,5-6.3H3628.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3851.4,1809.3v32.4h-40.4l20.8-13.5c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.2-0.1 c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2v-18H3851.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3830.4,1826.8l-22.9,14.9c-0.6-0.1-1.2-0.2-1.8-0.3c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.2-0.8-0.3 c-0.2-0.1-0.5-0.2-0.7-0.3c-3.1-1.7-5.7-5-7-9.1c-0.2-0.6-0.4-1.2-0.5-1.8c-0.1-0.2-0.1-0.5-0.2-0.8c-0.2-1.3-0.4-2.6-0.4-4 v-4.3h30C3828,1820.5,3830.2,1823.3,3830.4,1826.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3830.4,1792.9v28.2c-0.2-0.2-0.4-0.5-0.6-0.7c-0.4-0.4-0.8-0.7-1.2-1c-1-0.6-2.1-1-3.2-1h-227.1 c-1.2,0-2.3,0.4-3.2,1c-0.4,0.3-0.8,0.6-1.2,1c-0.2,0.2-0.4,0.4-0.6,0.7v-28.2c0-3.8,2.2-6.8,5-6.8h227.1 C3828.1,1786.1,3830.4,1789.2,3830.4,1792.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HAND_9_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4042.9,2202.1v392h-0.1c-43.4-7.4-97.1-21.3-155.7-41.9c-36.2-12.7-70.1-26.2-100.5-39.6l16.3-91 l27.7-154.5c-86.9-27.2-101-110.8-101-110.8h69.9c48.4,0,87.5-39.2,87.5-87.5V2040h-44.9c-31.5,0-57.1-31-57.1-62.5v-10.2h99.8 c18.5,0,35.9,8.7,47,23.5l73,97.5C4029.6,2121.1,4042.9,2161,4042.9,2202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M4042.9,2505.8v88.3h-0.1c-43.4-7.4-97.1-21.3-155.7-41.9c-36.2-12.7-70.1-26.2-100.5-39.6l16.3-91 c36,8.8,76,20.7,117.6,35.3c45,15.8,85.6,32.1,119.6,47.8C4041.2,2505,4042,2505.4,4042.9,2505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3891.6,2040h-48.2c-31.5,0-57.1-31-57.1-62.5v-10.2h105.3L3891.6,2040z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3861.3,2137.4c0,0,69.5,26.1,75.8,115.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 3830.8,
    y1: 2269.2,
    x2: 3878.1,
    y2: 2269.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CAP_6_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3786.7,1148l31.7-21c41.3-27.3,96.6-0.3,100.5,49l6.9,87.3c3.8,47.9,56.5,75.2,97.8,50.7l20-11.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3326,823.7 3733.3,1060.1 3938.4,1520.6 3703.1,1362.1 3447.4,1062.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "3327.1,807.8 3743,1049.3 3952.5,1519.5  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7641 -0.6451 0.6451 0.7641 56.0791 2589.7109)",
    className: "st10",
    cx: 3568.8,
    cy: 1218.2,
    rx: 45.1,
    ry: 201.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7641 -0.6451 0.6451 0.7641 48.8094 2585.7637)",
    className: "st2",
    cx: 3559.8,
    cy: 1226.1,
    rx: 44.2,
    ry: 197.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3736.9,1339.9l-38.8,32.7c7.2-6.1,5.6-21.5-3.1-43c-14.3-35.4-47.8-87.1-92.4-140.1 c-44.7-52.9-90.1-94.6-122.6-114.6c-19.7-12.2-34.7-16.4-41.9-10.3l38.8-32.7c19-16.1,96,36.5,167.8,121.6 C3716.5,1238.6,3756,1323.9,3736.9,1339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4151.4,1214.8c11-5.3,21.7-10,32-13.9c6.1,6.4,11.4,13.9,15.5,22.3c4.1,8.4,6.7,17.2,7.9,25.9 c-9.5,5.6-19.8,11.2-30.7,16.5c-54.7,26.5-104.5,36.6-111.3,22.6C4057.9,1274.1,4096.7,1241.3,4151.4,1214.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 4054.8,
    cy: 1295.1,
    r: 12.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__HAND__x26__CAP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DRESS_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M3340.7,2511.5v423.4h-482.3l61.8-459.8c0,18.6,94.1,41.8,210.2,51.8 C3246.5,2537,3340.7,2530.1,3340.7,2511.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3338.5,2500.6c0,18.6-93.3,25.5-208.3,15.4c-115-10.1-208.3-33.3-208.3-51.8c0,0,0,0,0,0 c0-18.6,93.3-25.5,208.3-15.4C3245.3,2458.8,3338.5,2482,3338.5,2500.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CAP_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M3405.4,1562l29.2,18.9c29.2,22.6-11.2,123.6-90.2,225.4c-79,101.9-166.7,166.1-195.9,143.5l-14.4-13.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2999.9,2036.4 3331.4,1733 3447.3,1380.1 3093.5,1701.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "2983,2073.2 3343.8,1743 3461.5,1384.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M3173.8,1732L2859,2033.1c-15.3,14.6-40.3,0.8-36-20l8.8-42.7c4-19.3-17.9-33.4-33.8-21.8l-104,75.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2609.3,2132.1c-9.3,7.8-18.6,15-27.6,21.3c-7.5-4.7-14.4-10.6-20.5-17.8c-6-7.2-10.7-15-14-23.2 c7.8-7.8,16.4-15.7,25.7-23.6c46.5-39.1,92.3-61.2,102.4-49.2C2685.3,2051.6,2655.8,2093,2609.3,2132.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 2684.3,
    cy: 2031.6,
    r: 12.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3188.7,2192.8v327c-18.5-0.8-38.2-2-58.5-3.8c-74.9-6.5-140.5-18.7-177.2-31.5l5.5-36.2l18.4-121.5h-23.8 c-33.9,0-61.3-27.4-61.3-61.3v-120.4c0-23.8,8.6-46.7,24.3-64.6l78.3-89.5c5.1-5.8,14.7-2.2,14.7,5.5v121.7 c0,14.6-5.2,28.7-14.7,39.8l-7,8.2h85c12.3,0,19.5-13.7,12.6-23.9c-10.5-15.3-24.3-37.1-37.4-62.3c-26.1-49.9,19.2-77.8,19.2-77.8 l103.7,134.5C3182.3,2153,3188.7,2172.7,3188.7,2192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3009.1,1990v128.2c0,14.6-5.2,28.7-14.7,39.8l-7,8.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 2987.4,
    y1: 2166.1,
    x2: 2931.2,
    y2: 2229.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3009.1,2062.5c0,14.6-5.2,28.7-14.7,39.8l-7,8.2l-56.1,63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3009.1,2006.9c0,14.6-5.2,28.7-14.7,39.8l-7,8.2l-56.1,63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 2976.9,
    y1: 2330.1,
    x2: 3020,
    y2: 2330.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3188.7,2455.2v64.6c-18.5-0.8-38.2-2-58.5-3.8c-74.9-6.5-140.5-18.7-177.2-31.5l5.5-36.2 c37.6-5.5,100.5-5.8,171.8,0.4C3150.5,2450.6,3170.1,2452.7,3188.7,2455.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x33__HAND__x26__CAP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAND_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DRESS_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2704.7,2934.9H2147V2382c0,23.6,91.7,42.7,204.9,42.7s204.9-19.1,204.9-42.7v-0.1L2704.7,2934.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2555.3,2371L2555.3,2371c0,23.7-90.7,42.8-202.7,42.8c-112,0-202.7-19.1-202.7-42.7v-0.1 c0.3-23.5,90.9-42.6,202.7-42.6S2555.1,2347.5,2555.3,2371z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND_5_",
    className: "st18",
    d: "M2555.3,2371.4c-0.7,23.4-91.2,42.4-202.7,42.4c-21.5,0-42.1-0.7-61.5-2v-205.7h-105.8 c-13.5,0-24.4-10.9-24.4-24.4v-16.5c0-7.4,3.3-14,8.5-18.5c-5.2-4.5-8.5-11.1-8.5-18.5v-16.5c0-6.5,2.6-12.5,6.8-16.8 c-4.2-4.4-6.8-10.3-6.8-16.8v-16.5c0-6.7,2.7-12.8,7.1-17.3c-4.4-4.4-7.1-10.5-7.1-17.2v-29.9c0-13.5,10.9-24.4,24.4-24.4h135.1 c4.5-2.6,11.8-11.8-0.6-17.2l-29-6.8c-23-11.5-37.6-30.6-37.6-56.4h102c17.1,0,32.4,10.8,38.2,26.9l159.4,445L2555.3,2371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2555.8,2371.6c-0.3-0.3-0.5-0.5-0.5-0.5c0,23.6-90.7,42.7-202.7,42.7c-21.5,0-42.1-0.7-61.5-2v-81.3 c19.4-1.3,40.1-2,61.5-2c101,0,184.8,15.6,200.2,35.9v0C2553.2,2364.9,2554.3,2367.6,2555.8,2371.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WINEGLASS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2322.7,1694.8v81.1c0,44.1-35.7,79.8-79.8,79.8c-44.1,0-79.8-35.7-79.8-79.8v-81.1 c0,19.8,35.7,35.8,79.8,35.8C2287,1730.6,2322.7,1714.6,2322.7,1694.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 2242.9,
    cy: 1694.8,
    rx: 79.8,
    ry: 35.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2322.7,1556.2v219.6c0,29.6-16.1,55.4-40,69.2c0,0,0,0-0.1,0c-11.7,6.7-25.3,10.6-39.7,10.6 c-14.4,0-27.9-3.8-39.6-10.5c-0.1,0-0.1-0.1-0.2-0.1c-23.9-13.8-40-39.6-40-69.2v-219.6H2322.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 2242.9,
    cy: 1556.2,
    rx: 80.7,
    ry: 35.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2242.9,
    cy: 1549.8,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 2216.9,
    cy: 1792.2,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2279.3,
    cy: 1694.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2196.1,
    cy: 1759.3,
    r: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2319.6,2262.1h-153.4c-2.8,0-3.6-3.7-1.2-5l53.6-20.3c8.4-3.2,14-11.3,14-20.3v-319.6 c0-21.2-11-41.1-29.3-51.8c11.7,6.7,25.2,10.5,39.6,10.5c14.5,0,28-3.9,39.7-10.6c-18.4,10.6-29.4,30.6-29.4,51.8v319.6 c0,9,5.6,17.1,14,20.3l53.6,20.3C2323.2,2258.4,2322.4,2262.1,2319.6,2262.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2186.1,
    cy: 1422.5,
    r: 13.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 2279.3,
    cy: 1446.2,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 2221.5,
    cy: 1495.4,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2217,
    cy: 1392.2,
    r: 7.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "FINGERS_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2345.7,2004.9v201.3h-160.4c-13.5,0-24.4-10.9-24.4-24.4v-16.5c0-7.4,3.3-14,8.5-18.5 c-5.2-4.5-8.5-11.1-8.5-18.5v-16.5c0-6.5,2.6-12.5,6.8-16.8c-4.2-4.4-6.8-10.3-6.8-16.8v-16.5c0-6.7,2.7-12.8,7.1-17.3 c-4.4-4.4-7.1-10.5-7.1-17.2v-22.2H2345.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2163.7,2126.9c0,15.3,12.4,27.7,27.7,27.7h129.8c15.3,0,27.7-12.4,27.7-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2163.7,2077c0,15.3,12.4,27.7,27.7,27.7h129.8c15.3,0,27.7-12.4,27.7-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2163.7,2027.1c0,15.3,12.4,27.7,27.7,27.7h129.8c15.3,0,27.7-12.4,27.7-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2190.1,2204.5h131.1c15.3,0,27.7-12.4,27.7-27.7v-187.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2226.3,1988.9H2213c-4.4,0-8,3.6-8,8l0,0c0,4.4,3.6,8,8,8h74.4c8,0,14.6-6.5,14.6-14.6l0,0 c0-9.6,7.8-17.4,17.4-17.4h12.1c9.6,0,17.4,7.8,17.4,17.4v32.4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CAP_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "3134.3,958.3 2801.4,1299.7 2417.6,876.6 2836.5,581.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "2788.4,1316.1 2385.7,874.7 2827.3,565.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2794.9,940.7l25.1-3.7c41.3-6.1,79.6,22.5,85.7,63.7l21.9,149.2c7.4,50.3,61.4,79.1,107.3,57.1l104.7-50.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3273.1,1185.5c10.7,5.8,20.8,11.8,30,17.8c-1.6,8.7-4.6,17.3-9,25.6c-4.4,8.2-10,15.5-16.4,21.6 c-10.1-4.4-20.7-9.5-31.4-15.3c-53.5-28.9-90.8-63.4-83.4-77.1C3170.3,1144.4,3219.6,1156.6,3273.1,1185.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 3151.5,
    cy: 1154.1,
    r: 12.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x32__HAND__x26__CAP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAND_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DRESS_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1961.7,2560.3v374.6h-432.9v-220.7c9.4,24.6,119.6,8.9,237.2-36.1 C1871.8,2637.6,1953.5,2587.8,1961.7,2560.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1961.7,2549.4c-8.3,27.5-89.9,77.3-195.8,117.8c-117.5,45-227.7,60.7-237.2,36.1s85.5-80.3,203.1-125.3 c117.5-45,220.5-61.5,229.9-36.9C1962.7,2543.6,1962.7,2546.4,1961.7,2549.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1870,2301v317.4l0,0l-23.9,12.1c-24.2,11.8-51.3,23.5-80.1,34.5c-52.9,20.3-104.4,34.6-145.8,42l23.8-93.5 l38.8-152.6c-18.4,0-35.8-8.2-47.5-22.4L1476,2257.3c27.3-24.9,68.1,9,68.1,9l-15.3-78.1c-3.6-18.5,1.8-37.7,14.5-51.6l48.4-53.1 c9.6-10.5,26.9-6.4,30.9,7.2l34.4,118.7c0,0,85.4,65.2,101.4,65.2c18.1,0,24.4-14.7-9.4-63c-25.4-36.3,0-62.8,0-62.8l82.7,69.6 C1856,2239,1870,2269.2,1870,2301z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1687.7,2282.5l-60.5-48.4l-33.1-114.2c-3.8-13.1-19.9-17-29.1-6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1648.1,2303.8l-52.6-42.8l-31.3-108.1c-3.6-12.4-19.4-16.1-28.1-6.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1601.6,
    y1: 2314.7,
    x2: 1544,
    y2: 2266.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1682.8,
    y1: 2460.9,
    x2: 1750.1,
    y2: 2460.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1870,2536.6v83.9c-29.8,15.8-65.3,31.8-104,46.7c-53,20.3-104.5,34.6-146,42l24-93.6 c26.6-12.8,56.4-25.6,87.9-37.6C1782.8,2558.6,1831,2544.4,1870,2536.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CAP_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1802.2,1480l30.4,66.7c2.9,24.7-14.7,47-39.4,50h0c-24.7,2.9-42.3,25.3-39.4,50l4.4,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2154,1265.7 2314.2,1015.7 1763.2,1011.3 1582.7,1491.9 1880.7,1477.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "2320.8,996.9 1744.7,990.4 1553.4,1494.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2144.1,1228.2c32,54.9-22.4,146.3-121.6,204.1c-99.2,57.8-205.5,60.1-237.5,5.2c-4.4-7.5-7.1-15.6-8.4-24.3 c-8-54.9,44.3-129.9,130-179.8c85.7-49.9,176.7-58.5,220.5-24.5C2134,1214.3,2139.7,1220.7,2144.1,1228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2118.7,1184.6l25.4,43.6c-4.4-7.5-10.1-13.9-17-19.3c-43.8-34-134.8-25.4-220.5,24.5 c-85.7,49.9-137.9,124.9-130,179.8c1.2,8.7,4,16.8,8.4,24.3l-25.4-43.6c-32-54.9,22.4-146.3,121.6-204.1 C1980.3,1132.1,2086.7,1129.7,2118.7,1184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1749.6,1818.5c-3.9,11.5-8.1,22.5-12.5,32.6c-8.9-0.1-17.9-1.6-26.7-4.6c-8.9-3-16.9-7.2-24.1-12.5 c2.6-10.7,5.8-22,9.7-33.5c19.4-57.6,47-100.2,61.8-95.3C1772.6,1710.2,1768.9,1760.9,1749.6,1818.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1759.8,
    cy: 1693.3,
    r: 12.1
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x31__HAND__x26__CAP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DRESS_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1243.5,2525.6v409.3H793.9v-602.4c8.8,29.5,102.9,91,219.7,142.4 C1137.9,2529.8,1240.9,2552.4,1243.5,2525.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1243.5,2514.7c-2.7,26.8-105.6,4.1-229.9-50.7c-116.8-51.5-210.9-113-219.7-142.4c-0.6-1.9-0.8-3.7-0.6-5.3 c2.6-26.8,105.6-4.1,229.9,50.7C1147.5,2421.8,1246.2,2487.9,1243.5,2514.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M977.4,1927.6c10.7-22,33-36,57.5-36h70.7l3.7,284.2l49.3,261.2l15.7,83c-41.6-9.2-98.4-28.5-160.6-55.9 c-35.2-15.5-79.3-38.5-108.7-54.7v-345.8c0-4.7,0.9-9.4,2.5-13.8L977.4,1927.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1174.2,2520L1174.2,2520c-41.6-9.2-98.4-28.5-160.6-55.9c-35.2-15.5-79.3-38.5-108.7-54.7v-86.9 c32.1,10.3,79.6,27.5,118.3,44.5c52.2,23,97.8,46.7,135.4,70L1174.2,2520z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DIPLOMA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1437.5,1572.1l-376.1,692c-13.9,25.6-52.2,31.7-85.5,13.6s-49-53.5-35.1-79.2l376.1-692L1437.5,1572.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4775 -0.8786 0.8786 0.4775 -633.0601 2014.4091)",
    className: "st4",
    cx: 1377.2,
    cy: 1539.5,
    rx: 52.8,
    ry: 68.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1191.8,1837l177.7-145.1l-2.8,51.6l56.9,14.2l-129.6,80c34.8-6,76.7-10.9,111.2-8.2 c41.1,3.2,27.3,51.3,11.9,92.4c36-3.5,156.7-76.6,202.2-62.8c27.8,8.4,17.8,65.1,9.8,96.4c11.6,0.6,70.3-0.1,70.3-0.1l-31,28.3 l17,28.3c-66,2.9-66.8-7.5-58.5-54.3c1.4-50.9-55-2-175.1,26.7c-59.5,14.2-51.8-24.5-37.1-64.8c-5.9-18.5-50-38.6-191.7-1.6 L1191.8,1837z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 1194.4,
    cy: 1872.9,
    r: 52.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "FINGERS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1176.3,1891.6v3.3c0,33.6-27.2,60.9-60.9,60.9h-63.9v-64.2H1176.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1254.1,2014.9l-16.9,39.6l-19.7,46.3l-10.7,25.1l-16.3,38.3c-0.4,1-1,2.1-1.5,3c0,0.1-0.1,0.1-0.1,0.2 c-5.2,9-15.3,14.6-26.4,14.6h-129.5c-15.7,0-26.4-14.9-20.6-28.6l9.4-22.1l20.7-48.6l17.8-41.9l15.7-36.8 c4.6-10.8,15.7-17.9,28.1-17.9h129.5C1249.2,1986.3,1259.9,2001.2,1254.1,2014.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1065.7,2041c5.4-6,13.2-9.6,21.6-9.6H1211c13,0,22.4,11.2,21.1,23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1048.9,2082.9c5.3-5.3,12.6-8.4,20.5-8.4h123.7c14.2,0,24,13.2,20.4,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1029.5,2131.4c5.3-5,12.4-7.9,20-7.9h123.7c14.6,0,24.7,14.2,20,27.6c0,0,0,0,0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "CAP_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1476.8,851.8c8.3-8.9,16.6-17.2,24.8-24.6c8,3.7,15.6,8.8,22.5,15.2c6.8,6.4,12.5,13.6,16.8,21.3 c-6.8,8.7-14.4,17.6-22.7,26.5c-41.4,44.5-84.1,72-95.6,61.4C1411.2,941,1435.4,896.3,1476.8,851.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1186.2,1204.2l-13.2,8.2c-47.9,29.7-141.2-34.2-208.3-142.7c-67.2-108.5-82.8-220.4-35-250.1l13.6-8.4 l80.9,238L1186.2,1204.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1320.2,1332.5 1186.2,1204.2 1024.1,1049.1 943.2,811.2 870.9,598.5 1207.6,869.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "1330.7,1319.8 1218.9,857.9 878,589.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1142.3,1005.4c-8.6-35.6,13.3-71.5,48.9-80.1l0,0c33.8-8.2,68.1,11.1,78.7,44.1l28.1,90.7 c15.5,50.2,87.8,46.3,97.9-5.3l16.2-83.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1415.9,
    cy: 961.7,
    r: 12.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/Graduation.337a020d731be6907c21fdb326ab4b31.svg";
export { ForwardRef as ReactComponent };